/**
 * @deprecated Use ClientTrackingName instead
 */
export type ClientTrackingNameType = 'change_language' |
    'success' |
    'error';

/**
 * @deprecated Use ClientTrackingName instead
 */
export class ClientTrackingNames {
    static readonly ChangeLanguage: ClientTrackingNameType = 'change_language';
    static readonly Success: ClientTrackingNameType = 'success';
    static readonly Error: ClientTrackingNameType = 'error';

}



// WEBPACK FOOTER //
// ./src/models/ClientTrackingNameType.ts